<div
  *ngIf="isMetric === false"
  class="select-none"
  [ngClass]="{
    'flex-wrap': isWrap === true,
    truncate: isWrap === false
  }"
>
  <span *ngIf="isAddPrefixRowId === true" class="mr-2"
    >({{ rowId | capitalize }})</span
  >

  <span>
    {{ name | capitalize }}
  </span>
</div>

<div
  *ngIf="
    isMetric === true &&
    showMetricsModelName === false &&
    showMetricsTimeFieldName === false
  "
  class="select-none"
  [ngClass]="{
    'flex-wrap': isWrap === true,
    truncate: isWrap === false
  }"
>
  <span *ngIf="isAddPrefixRowId === true" class="mr-2"
    >({{ rowId | capitalize }})</span
  >

  <span>{{ partNodeLabel | capitalize }}</span>

  <span class="ml-2 font-semibold">{{ partFieldLabel | capitalize }}</span>
</div>

<div
  class="select-none"
  [ngClass]="{
    'flex-wrap': isWrap === true,
    truncate: isWrap === false
  }"
  *ngIf="
    isMetric === true &&
    showMetricsModelName === true &&
    showMetricsTimeFieldName === true
  "
>
  <span *ngIf="isAddPrefixRowId === true" class="mr-2"
    >({{ rowId | capitalize }})</span
  >

  <span>{{ partNodeLabel | capitalize }}</span>

  <span class="ml-2 font-semibold">{{ partFieldLabel | capitalize }}</span>

  <span class="ml-2">by {{ timeNodeLabel | capitalize }}</span>

  <span class="ml-2">{{ timeFieldLabel | capitalize }}</span>

  <span class="ml-[6px]">- {{ topLabel | capitalize }}</span>
</div>

<div
  class="select-none"
  [ngClass]="{
    'flex-wrap': isWrap === true,
    truncate: isWrap === false
  }"
  *ngIf="
    isMetric === true &&
    showMetricsModelName === true &&
    showMetricsTimeFieldName === false
  "
>
  <span>{{ partNodeLabel | capitalize }}</span>

  <span class="ml-2 font-semibold">{{ partFieldLabel | capitalize }}</span>

  <span class="ml-[6px]">- {{ topLabel | capitalize }}</span>
</div>

<div
  class="select-none"
  [ngClass]="{
    'flex-wrap': isWrap === true,
    truncate: isWrap === false
  }"
  *ngIf="
    isMetric === true &&
    showMetricsModelName === false &&
    showMetricsTimeFieldName === true
  "
>
  <span>{{ partNodeLabel | capitalize }}</span>

  <span class="ml-2 font-semibold">{{ partFieldLabel | capitalize }}</span>

  <span class="ml-2">by {{ timeNodeLabel | capitalize }}</span>

  <span class="ml-2">{{ timeFieldLabel | capitalize }}</span>
</div>
